import React, { useState } from 'react';
import { Button, Input, FormControl, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, useToast, Text } from '@chakra-ui/react';
import { loadStripe } from '@stripe/stripe-js';
import { borderColor } from './colors';

const isTestMode = process.env.REACT_APP_STRIPE_TEST_MODE === "true";
const key = isTestMode
  ? process.env.REACT_APP_STRIPE_TEST_KEY
  : process.env.REACT_APP_STRIPE_LIVE_KEY;
if (!key) {
  throw new Error('Stripe key is not defined. Please check your environment variables.');
}
const stripePromise = loadStripe(key);

const CheckoutButton = ({ seatIds }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [name, setName] = useState('');
  const [surname, setSurname] = useState('');
  const [email, setEmail] = useState('');
  const [telefono, setTelefono] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const toast = useToast();
  // Determina l'URL del server in base alla modalità di test
  const isLocalMode = process.env.REACT_APP_LOCAL_MODE === "true";
  const server = isLocalMode ? process.env.REACT_APP_TEST_URL_BACKEND : process.env.REACT_APP_LIVE_URL_BACKEND;


  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validateTelefono = (telefono) => /^\d{10}$/.test(telefono);

  const handleSeatValidation = async () => {
    setLoading(true);
    const response = await fetch(`${server}/check-seats`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ seatIds }),
    });

    const { success } = await response.json();
    setLoading(false);

    return success;
  };

  const handleCheckout = async () => {
    if (!name) {
      setError('Per favore, inserisci il tuo nome.');
      return;
    }
    if (!surname) {
      setError('Per favore, inserisci il tuo cognome.');
      return;
    }
    if (!validateEmail(email)) {
      setError('Per favore, inserisci un\'email valida.');
      return;
    }
    if (!validateTelefono(telefono)) {
      setError('Per favore, inserisci un numero di telefono valido.');
      return;
    }

    // Attendi la validazione dei posti
    const isSeatValid = await handleSeatValidation();

    // Se la validazione fallisce, mostra il modal di errore e fermati qui
    if (!isSeatValid) {
      setIsErrorModalOpen(true);
      return;
    }

    setLoading(true);

    const response = await fetch(`${server}/create-checkout-session`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ seatIds, customerEmail: email, customerName: name, customerSurname: surname, customerTelefono: telefono }),
    });

    const { id } = await response.json();
    const stripe = await stripePromise;
    if (stripe) {
      await stripe.redirectToCheckout({ sessionId: id });
    }

    setLoading(false);
    setIsModalOpen(false);
  };

  const handleButtonClick = async () => {
    if (seatIds.length === 0) {
      toast({
        title: "Nessun posto selezionato",
        status: "error",
        isClosable: true,
        duration: 2000,
      });
      return;
    }

    if (seatIds.length > 40) {
      toast({
        title: "Limite di posti superato",
        description: "Hai selezionato più di 40 posti. Per favore, riduci il numero di posti selezionati.",
        status: "error",
        isClosable: true,
        duration: 2000,
      });
      return;
    }

    //const isValid = await handleSeatValidation();
    const isValid = true;

    if (isValid) {
      setIsModalOpen(true);
    }

  };

  return (
    <>
      <Button
        bg={borderColor}
        color="white"
        mt="1.5vh"
        width={"100%"}
        size={{ base: "sm", md: "md" }}

        _hover={{ bg: 'transparent', color: borderColor, border: `2px solid ${borderColor}` }}
        onClick={handleButtonClick}
        disabled={loading || seatIds.length === 0}
      >
        {loading ? 'In Elaborazione...' : 'CONFERMA PRENOTAZIONE'}
      </Button>

      {/* Modal per inserire i dati utente */}
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Inserisci i tuoi dati</ModalHeader>
          <ModalBody>
            <FormControl mb={4}>
              <Input placeholder="Nome" value={name} onChange={(e) => setName(e.target.value)} />
            </FormControl>
            <FormControl mb={4}>
              <Input placeholder="Cognome" value={surname} onChange={(e) => setSurname(e.target.value)} />
            </FormControl>
            <FormControl mb={4}>
              <Input placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
            </FormControl>
            <FormControl mb={4}>
              <Input placeholder="Telefono" value={telefono} onChange={(e) => setTelefono(e.target.value)} />
            </FormControl>
            {error && <Text color="red">{error}</Text>}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={handleCheckout} disabled={loading}>
              {loading ? 'In Elaborazione...' : 'Conferma'}
            </Button>
            <Button onClick={() => setIsModalOpen(false)}>Annulla</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Modal di errore */}
      <Modal isOpen={isErrorModalOpen} onClose={() => setIsErrorModalOpen(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Posti non disponibili</ModalHeader>
          <ModalBody>
            <Text>Alcuni posti che hai selezionato sono in fase di prenotazione da un altro utente. Ricarica la pagina e riprova.</Text>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red" onClick={() => window.location.reload()}>
              Ricarica Pagina
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default CheckoutButton;
